var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("div", { staticClass: "applicant-container section-wrapper" }, [
        _c(
          "div",
          {
            ref: "personal-details",
            staticClass: "personal-details single-card card",
            attrs: { id: "personal-details" },
          },
          [
            _c("resize-sensor", {
              attrs: { debounce: 200, throttle: 100 },
              on: {
                resized: function (el) {
                  return _vm.handleResize("personal-details")
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "resize-wrapper h-auto" }, [
              _c(
                "div",
                {
                  staticClass: "card-header px-5",
                  attrs: {
                    id: _vm._f("hashId")(_vm.identifier + "[personal-details]"),
                  },
                },
                [
                  _c("div", { staticClass: "row align-items-end" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("application-card-header", {
                          attrs: {
                            "invisible-tile":
                              _vm.isTypeCoApplicant && !_vm.coAppsPage,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "application-form.personal-details"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "title-right",
                              fn: function () {
                                return [
                                  !_vm.editVisibility && !_vm.isTypeCoApplicant
                                    ? _c("swap-applicants-dropdown", {
                                        attrs: {
                                          disabled: !_vm.coapp,
                                          "client-username": _vm.clientUsername,
                                          "agent-username": _vm.agentUsername,
                                          "application-id": _vm.applicationId,
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "sub-title",
                              fn: function () {
                                return [
                                  _vm.firstName || _vm.lastName
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.fullNameWithSalutation)
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "extra",
                              fn: function () {
                                return [
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        "d-flex flex-row align-items-center":
                                          _vm.isTypeCoApplicant &&
                                          _vm.applicantIndex === 1,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.typeTitle) +
                                          "\n                    "
                                      ),
                                      !_vm.editVisibility &&
                                      _vm.isTypeCoApplicant &&
                                      _vm.applicantIndex === 1
                                        ? _c("checkbox-section", {
                                            attrs: {
                                              name: "coapp",
                                              label: _vm.$t(
                                                "global.words.disabled"
                                              ),
                                              checked: _vm.coapp,
                                              "true-value": false,
                                              "false-value": true,
                                              "stop-propagation": "",
                                              "container-class":
                                                "mb-0 text-capitalize ml-3 disable-coapp-checkbox",
                                            },
                                            on: {
                                              change: _vm.handleDisableCoapp,
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.editVisibility &&
                                      _vm.isTypeCoApplicant &&
                                      _vm.applicantIndex === 1 &&
                                      _vm.allowDeleteFirstCoapp
                                        ? _c("inline-prompt", {
                                            ref: "delete-coapp-prompt",
                                            staticClass:
                                              "d-inline-block bold text-gray ml-2",
                                            attrs: {
                                              "action-type": "delete",
                                              "confirmation-text": _vm.$t(
                                                "application.messages.allDataWillBeLost"
                                              ),
                                            },
                                            on: {
                                              accept: function ($event) {
                                                return _vm.handleRemoveCoapp(
                                                  0,
                                                  "['co-applicants']"
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { key: _vm.coapp, staticClass: "card-body px-5 pb-5" },
                [
                  _c(
                    "div",
                    { staticClass: "row align-items-end" },
                    [
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [
                              _vm.visibilityPaths.salutation,
                            ],
                            "size-class": "col-lg-3",
                            title: _vm.$t("application-form.salutation"),
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("select-section", {
                            attrs: {
                              disabled:
                                !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                              name: "salutation",
                              options: _vm.salutationOptions,
                              tabindex: _vm.tabIndex(100),
                            },
                            model: {
                              value: _vm.salutation,
                              callback: function ($$v) {
                                _vm.salutation = $$v
                              },
                              expression: "salutation",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "size-class": "col-lg-3",
                            title: _vm.$t("application-form.first-name"),
                            "visibility-paths": [_vm.visibilityPaths.firstName],
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("text-section", {
                            attrs: {
                              disabled:
                                !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                              name: "first-name",
                              tabindex: _vm.tabIndex(100),
                              "max-length": "20",
                              label: _vm.$t("application-form.first-name"),
                            },
                            model: {
                              value: _vm.firstName,
                              callback: function ($$v) {
                                _vm.firstName = $$v
                              },
                              expression: "firstName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [
                              _vm.visibilityPaths.middleName,
                            ],
                            title: _vm.$t("application-form.middle-name"),
                            "size-class":
                              "col-lg-3 " + (_vm.editVisibility ? "mt-3" : ""),
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("text-section", {
                            attrs: {
                              disabled:
                                !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                              name: "middle-name",
                              tabindex: _vm.tabIndex(100),
                              label: _vm.$t("application-form.middle-name"),
                            },
                            model: {
                              value: _vm.middleName,
                              callback: function ($$v) {
                                _vm.middleName = $$v
                              },
                              expression: "middleName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [_vm.visibilityPaths.lastName],
                            title: _vm.$t("application-form.last-name"),
                            "size-class":
                              "col-lg-3 " + (_vm.editVisibility ? "mt-3" : ""),
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("text-section", {
                            attrs: {
                              disabled:
                                !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                              name: "last-name",
                              tabindex: _vm.tabIndex(100),
                              "max-length": "40",
                              label: _vm.$t("application-form.last-name"),
                            },
                            model: {
                              value: _vm.lastName,
                              callback: function ($$v) {
                                _vm.lastName = $$v
                              },
                              expression: "lastName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "row align-items-end pb-2",
                      attrs: { id: "email-section" },
                    },
                    [
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [_vm.visibilityPaths.email],
                            "size-class": "col-lg-12",
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("div", { staticClass: "field-title-with-copy" }, [
                            _c("span", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$tc("application-form.email", 1)) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("i", {
                              staticClass:
                                "clickable fa fa-clipboard copy-link",
                              class: {
                                "copy-icon--disabled":
                                  !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                              },
                              staticStyle: { "font-size": "0.6em" },
                              attrs: {
                                title: _vm.$t("application-form.copy-email"),
                              },
                              on: { click: _vm.copyEmail },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("text-section", {
                            attrs: {
                              disabled:
                                !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                              name: "emailNoFill",
                              type: "email",
                              pattern: "^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$",
                              tabindex: _vm.tabIndex(100),
                              "max-length": "50",
                              label: _vm.$tc("application-form.email", 1),
                            },
                            model: {
                              value: _vm.email,
                              callback: function ($$v) {
                                _vm.email = $$v
                              },
                              expression: "email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row align-items-end" },
                    [
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [
                              _vm.visibilityPaths.phoneNumber,
                            ],
                            "size-class": "col-lg-4 col-md-6 col-12",
                            title: _vm.$t("application-form.cell-phone-number"),
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("text-section", {
                            attrs: {
                              disabled:
                                !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                              name: "phone-number",
                              "class-name": "fe-phone",
                              tabindex: _vm.tabIndex(100),
                              label: _vm.$t(
                                "application-form.cell-phone-number"
                              ),
                            },
                            model: {
                              value: _vm.phoneNumber,
                              callback: function ($$v) {
                                _vm.phoneNumber = $$v
                              },
                              expression: "phoneNumber",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [
                              _vm.visibilityPaths.altPhoneNumber,
                            ],
                            "size-class": "col-lg-4 col-md-6 col-12",
                            title: _vm.$t("application-form.home-phone-number"),
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("text-section", {
                            attrs: {
                              disabled:
                                !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                              name: "alt-phone-number",
                              "class-name": "fe-phone",
                              tabindex: _vm.tabIndex(100),
                              label: _vm.$t(
                                "application-form.home-phone-number"
                              ),
                            },
                            model: {
                              value: _vm.altPhoneNumber,
                              callback: function ($$v) {
                                _vm.altPhoneNumber = $$v
                              },
                              expression: "altPhoneNumber",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [_vm.visibilityPaths.workPhone],
                            "size-class": "col-lg-4 col-md-6 col-12",
                            title: _vm.$t("application-form.work-phone-number"),
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("text-section", {
                            attrs: {
                              disabled:
                                !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                              name: "work-phone-number",
                              "class-name": "fe-phone fe-phone-ext",
                              tabindex: _vm.tabIndex(100),
                              label: _vm.$t(
                                "application-form.work-phone-number"
                              ),
                            },
                            model: {
                              value: _vm.workPhone,
                              callback: function ($$v) {
                                _vm.workPhone = $$v
                              },
                              expression: "workPhone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row align-items-end" },
                    [
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [
                              _vm.visibilityPaths.dateOfBirth,
                            ],
                            "size-class": "col-lg-4 col-md-6 col-12",
                            title: _vm.$t("application-form.date-of-birth"),
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("date-section", {
                            attrs: {
                              disabled:
                                !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                              name: "date-of-birth",
                              placeholder: "YYYY-MM-DD",
                              "class-name": "date-format past-date",
                              tabindex: _vm.tabIndex(100),
                              "past-date": "",
                              label: _vm.$t("application-form.date-of-birth"),
                              calendar: "",
                            },
                            on: { change: _vm.handleSave },
                            model: {
                              value: _vm.dateOfBirth,
                              callback: function ($$v) {
                                _vm.dateOfBirth = $$v
                              },
                              expression: "dateOfBirth",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [_vm.visibilityPaths.sin],
                            "size-class": "col-lg-4 col-md-6 col-12",
                            title: _vm.$t(
                              "application-form.social-insurance-number"
                            ),
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("sin-section", {
                            attrs: {
                              disabled:
                                !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                              name: "sin",
                              applicant: "",
                              placeholder: "XXX-XXX-XXX",
                              show: _vm.showSIN,
                              loading: _vm.loadingSIN,
                              tabindex: _vm.tabIndex(100),
                              label: _vm.$t(
                                "application-form.social-insurance-number"
                              ),
                            },
                            model: {
                              value: _vm.sin,
                              callback: function ($$v) {
                                _vm.sin = $$v
                              },
                              expression: "sin",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "field",
                        {
                          attrs: {
                            "visibility-paths": [
                              _vm.visibilityPaths.languagePreference,
                            ],
                            "edit-visibility": _vm.editVisibility,
                            "size-class": "col-lg-4 col-md-6 col-12",
                            title: _vm.$t(
                              "application-form.language-preference"
                            ),
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("select-section", {
                            key: _vm.forceUpdate,
                            attrs: {
                              value: _vm.languagePreference,
                              disabled:
                                !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                              name: "language-preference",
                              options: _vm.languagePreferenceOptions,
                              tabindex: _vm.tabIndex(100),
                            },
                            on: { change: _vm.handleLanguageChange },
                          }),
                          _vm._v(" "),
                          !_vm.isTypeCoApplicant
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-modal",
                                    {
                                      ref: "changeLanguageModal",
                                      attrs: {
                                        title: _vm.$t(
                                          "application.actions.changeLanguage"
                                        ),
                                        "ok-title": _vm.$t(
                                          "global.actions.changeLanguage"
                                        ),
                                        "cancel-title": _vm.$t(
                                          "global.words.cancel"
                                        ),
                                        "cancel-variant": "white",
                                      },
                                      on: {
                                        hide: _vm.onHide,
                                        ok: _vm.handleOk,
                                        cancel: _vm.handleCancel,
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "d-block" }, [
                                        _c("p", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "application.messages.confirmLanguageChange"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row align-items-end" },
                    [
                      _c(
                        "field",
                        {
                          attrs: {
                            "visibility-paths": [
                              _vm.visibilityPaths.maritalStatus,
                            ],
                            "edit-visibility": _vm.editVisibility,
                            "size-class": "col-lg-4 col-md-6 col-12",
                            title: _vm.$t("application-form.marital-status"),
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("select-section", {
                            attrs: {
                              disabled:
                                !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                              name: "marital-status",
                              options: _vm.maritalStatusOptions,
                              tabindex: _vm.tabIndex(100),
                            },
                            model: {
                              value: _vm.maritalStatus,
                              callback: function ($$v) {
                                _vm.maritalStatus = $$v
                              },
                              expression: "maritalStatus",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isTypeCoApplicant
                        ? _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "size-class": "col-lg-4",
                                "long-title": true,
                                "visibility-paths": [
                                  _vm.visibilityPaths
                                    .relationshipToMainApplicant,
                                ],
                                title: _vm.$t(
                                  "application-form.relation-to-main-applicant"
                                ),
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("select-section", {
                                attrs: {
                                  disabled:
                                    !_vm.hasCoApplicant &&
                                    _vm.isTypeCoApplicant,
                                  name: "relationship-to-main-applicant",
                                  options: _vm.coApplicantRelationOptions,
                                  tabindex: _vm.tabIndex(100),
                                },
                                model: {
                                  value: _vm.relationshipToMainApplicant,
                                  callback: function ($$v) {
                                    _vm.relationshipToMainApplicant = $$v
                                  },
                                  expression: "relationshipToMainApplicant",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isTypeCoApplicant
                        ? _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "size-class": "col-lg-4",
                                "visibility-paths": [
                                  _vm.visibilityPaths.coApplicantType,
                                ],
                                "title-class": "d-lg-block d-none",
                                title: _vm.$t("application-form.type"),
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("select-section", {
                                attrs: {
                                  disabled:
                                    !_vm.hasCoApplicant &&
                                    _vm.isTypeCoApplicant,
                                  name: "co-applicant-type",
                                  options: _vm.coapplicantTypeOptions,
                                  tabindex: _vm.tabIndex(100),
                                },
                                model: {
                                  value: _vm.coApplicantType,
                                  callback: function ($$v) {
                                    _vm.coApplicantType = $$v
                                  },
                                  expression: "coApplicantType",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isTypeCoApplicant
                        ? _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "size-class": "col-lg-4 col-md-6 col-12",
                                title: _vm.$t("application-form.dependents"),
                                "visibility-paths": [
                                  _vm.visibilityPaths.numChildren,
                                ],
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("text-section", {
                                attrs: {
                                  disabled:
                                    !_vm.hasCoApplicant &&
                                    _vm.isTypeCoApplicant,
                                  name: "num-children",
                                  placeholder: "0",
                                  "class-name": "fe-num-field",
                                  tabindex: _vm.tabIndex(100),
                                  label: _vm.$t("application-form.dependents"),
                                },
                                model: {
                                  value: _vm.numChildren,
                                  callback: function ($$v) {
                                    _vm.numChildren = $$v
                                  },
                                  expression: "numChildren",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "row align-items-end justify-content-between",
                    },
                    [
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [
                              _vm.visibilityPaths.firstTimeHomeBuyer,
                            ],
                            "size-class":
                              "col-lg-4 col-md-6 col-12 radio-field",
                            title: _vm.$t("application-form.first-home"),
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("radio-section", {
                            attrs: {
                              name: "first-time-home-buyer",
                              options: _vm.basicBinaryOptions,
                              path: _vm.type,
                              "full-width": true,
                              tabindex: _vm.tabIndex(100),
                              disabled:
                                !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                            },
                            model: {
                              value: _vm.firstTimeHomeBuyer,
                              callback: function ($$v) {
                                _vm.firstTimeHomeBuyer = $$v
                              },
                              expression: "firstTimeHomeBuyer",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.applicantIndex === 0 && _vm.hasReferralPartners
                        ? _c(
                            "field",
                            [
                              _c("simple-button", {
                                attrs: {
                                  "class-name": "btn mr-2 btn-primary",
                                  text: _vm.$t(
                                    "application-form.lifeInsurance"
                                  ),
                                },
                                on: { click: _vm.handleOpenLifeInsuranceModal },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "identifications",
            staticClass: "identifications single-card card",
            attrs: { id: "identifications" },
          },
          [
            _c("resize-sensor", {
              attrs: { debounce: 50 },
              on: {
                resized: function (el) {
                  return _vm.handleResize("identifications")
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "resize-wrapper h-auto" }, [
              _c(
                "div",
                {
                  staticClass: "card-header px-5",
                  attrs: {
                    id: _vm._f("hashId")(_vm.identifier + "[identifications]"),
                  },
                },
                [
                  _c("div", { staticClass: "row align-items-end" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("application-card-header", {
                          attrs: {
                            "invisible-tile":
                              _vm.isTypeCoApplicant && !_vm.coAppsPage,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$tc(
                                            "application-form.identification",
                                            2
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              !_vm.isTypeCoApplicant
                                ? {
                                    key: "title-right",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "mr-3" },
                                              [
                                                _c("icon", {
                                                  staticClass:
                                                    "text-primary mr-2",
                                                  attrs: {
                                                    "data-toggle": "tooltip",
                                                    title: _vm.$t(
                                                      "application-form.verifast"
                                                    ),
                                                    name: "info-circle",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: "https://app.verifast.com/loginv1",
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        height: "20px",
                                                        src: require("@Broker/assets/icon/verifast-logo.svg"),
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              [
                                                _c("icon", {
                                                  staticClass:
                                                    "text-primary mr-2",
                                                  attrs: {
                                                    "data-toggle": "tooltip",
                                                    title: _vm.$t(
                                                      "application-form.fastkeyTooltip"
                                                    ),
                                                    name: "info-circle",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: "https://fastkey.com/register?secret=4e056e09f27f92ef0feb56929450f2ca%3Aa6d03bc363312bdef583a9f9d5857ef9fbb71db6e1",
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        height: "20px",
                                                        src: require("@Broker/assets/icon/fastkey-logo.svg"),
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  }
                                : null,
                              {
                                key: "sub-title",
                                fn: function () {
                                  return [
                                    _vm.firstName || _vm.lastName
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.fullNameWithSalutation)
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "extra",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.typeTitle) +
                                        "\n                "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body px-5 pb-5" },
                [
                  _c(
                    "group-set",
                    {
                      attrs: {
                        disabled: !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                        "group-name": _vm.$tc(
                          "application-form.identification",
                          1
                        ),
                        multi: !_vm.editVisibility,
                        path: _vm.type + "['identifications']",
                        source: _vm.dataByType["identifications"],
                        "start-empty": !_vm.editVisibility,
                        tabindex: _vm.tabIndex(200),
                      },
                      on: { duplicate: _vm.handleDuplicate },
                    },
                    _vm._l(
                      _vm.identifications,
                      function (identification, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "row align-items-end mb-5",
                            attrs: {
                              id: _vm._f("hashId")(
                                _vm.identifier +
                                  "[identifications][" +
                                  index +
                                  "]"
                              ),
                              "group-index": index,
                            },
                          },
                          [
                            !_vm.editVisibility
                              ? _c("field", {
                                  attrs: {
                                    "size-class": "col-lg-12",
                                    "title-class":
                                      "text-secondary form-title-removable text-lower-case",
                                    title:
                                      _vm.ordinalIndex(index) +
                                      " " +
                                      _vm.$tc(
                                        "application-form.identification",
                                        1
                                      ),
                                    removable: !_vm.editVisibility,
                                    "remove-path":
                                      _vm.type + "['identifications']",
                                  },
                                  on: {
                                    remove: function (removePath) {
                                      return _vm.handleRemove(
                                        index,
                                        removePath,
                                        "identifications",
                                        true
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "field",
                              {
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.identifications +
                                      "[type]",
                                  ],
                                  "size-class": _vm.isMainApplicantScreen
                                    ? "col-xl-4 col-sm-6 col-12"
                                    : "col-lg-4",
                                  title: _vm.$t(
                                    "application-form.identification-type"
                                  ),
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("select-section", {
                                  attrs: {
                                    disabled:
                                      !_vm.hasCoApplicant &&
                                      _vm.isTypeCoApplicant,
                                    name: "type",
                                    options: _vm.identificationTypeOptions,
                                    tabindex: _vm.tabIndex(200),
                                  },
                                  model: {
                                    value: identification.type,
                                    callback: function ($$v) {
                                      _vm.$set(identification, "type", $$v)
                                    },
                                    expression: "identification.type",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "field",
                              {
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.identifications +
                                      "[country]",
                                  ],
                                  title: _vm.$t(
                                    "application-form.issuing-country"
                                  ),
                                  "size-class": _vm.isMainApplicantScreen
                                    ? "col-xl-4 col-sm-6 col-12"
                                    : "col-lg-4",
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("text-section", {
                                  attrs: {
                                    disabled:
                                      !_vm.hasCoApplicant &&
                                      _vm.isTypeCoApplicant,
                                    name: "country",
                                    tabindex: _vm.tabIndex(200),
                                    "max-length": "30",
                                    label: _vm.$t(
                                      "application-form.issuing-country"
                                    ),
                                  },
                                  model: {
                                    value: identification.country,
                                    callback: function ($$v) {
                                      _vm.$set(identification, "country", $$v)
                                    },
                                    expression: "identification.country",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "field",
                              {
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.identifications +
                                      "[number]",
                                  ],
                                  title: _vm.$t("application-form.id-number"),
                                  "size-class": _vm.isMainApplicantScreen
                                    ? "col-xl-4 col-12"
                                    : "col-lg-4",
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("text-section", {
                                  attrs: {
                                    disabled:
                                      !_vm.hasCoApplicant &&
                                      _vm.isTypeCoApplicant,
                                    name: "number",
                                    tabindex: _vm.tabIndex(200),
                                    "max-length": "30",
                                    label: _vm.$t("application-form.id-number"),
                                  },
                                  model: {
                                    value: identification.number,
                                    callback: function ($$v) {
                                      _vm.$set(identification, "number", $$v)
                                    },
                                    expression: "identification.number",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }
                    ),
                    0
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.editVisibility
          ? _c(
              "div",
              {
                staticClass: "card application-card",
                attrs: { id: "fintrac-risk-level" },
              },
              [
                _c("resize-sensor", {
                  attrs: { debounce: 50 },
                  on: {
                    resized: function () {
                      return _vm.handleResize("fintrac-risk-level")
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "resize-wrapper h-auto" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card-header px-5",
                        attrs: {
                          id: _vm._f("hashId")(
                            _vm.identifier + "[personal-details][risklevel]"
                          ),
                        },
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("application-card-header", {
                                attrs: {
                                  "invisible-tile":
                                    _vm.isTypeCoApplicant && !_vm.coAppsPage,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "application-form.fintrac-risk-level"
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "sub-title",
                                      fn: function () {
                                        return [
                                          _vm.firstName || _vm.lastName
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.fullNameWithSalutation
                                                  )
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "extra",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.typeTitle) +
                                              "\n                "
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3468821109
                                ),
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-body px-5 pb-5" }, [
                      _c(
                        "div",
                        { staticClass: "row align-items-end" },
                        [
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.risklevel,
                                ],
                                "size-class": "col-lg-6 col-md-6",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("radio-section", {
                                attrs: {
                                  name: "risklevel",
                                  options: _vm.fintracRiskLevelData,
                                  path: _vm.type,
                                  tabindex: _vm.tabIndex(1000),
                                  disabled:
                                    !_vm.hasCoApplicant &&
                                    _vm.isTypeCoApplicant,
                                  "horizontal-style": true,
                                },
                                on: { change: _vm.handleSave },
                                model: {
                                  value: _vm.risklevel,
                                  callback: function ($$v) {
                                    _vm.risklevel = $$v
                                  },
                                  expression: "risklevel",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("generic-modal", {
                      ref: "highRiskTransactionModal",
                      attrs: { id: "highRiskTransaction" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "body",
                            fn: function () {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "application-form.highrisk-transactionmodalbody"
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2100526433
                      ),
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "addresses",
            staticClass: "addresses single-card card",
            attrs: { id: "addresses" },
          },
          [
            _c("resize-sensor", {
              attrs: { debounce: 50 },
              on: {
                resized: function () {
                  return _vm.handleResize("addresses")
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "resize-wrapper h-auto" }, [
              _c(
                "div",
                {
                  staticClass: "card-header px-5",
                  attrs: {
                    id: _vm._f("hashId")(
                      _vm.identifier + "[personal-details][addresses]"
                    ),
                  },
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("application-card-header", {
                          attrs: {
                            "invisible-tile":
                              _vm.isTypeCoApplicant && !_vm.coAppsPage,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$tc("application-form.address", 2)
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "sub-title",
                              fn: function () {
                                return [
                                  _vm.firstName || _vm.lastName
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.fullNameWithSalutation)
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "extra",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.typeTitle) +
                                      "\n                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "card-body px-5 pb-5" }, [
                _c(
                  "div",
                  { staticClass: "row align-items-start mb-4" },
                  [
                    _c(
                      "field",
                      {
                        attrs: {
                          "edit-visibility": _vm.editVisibility,
                          "visibility-paths": [
                            _vm.visibilityPaths.own,
                            _vm.visibilityPaths.monthlyRent,
                          ],
                          "size-class": "col-auto radio-field",
                          title: _vm.$t(
                            "application-form.current-residential-status"
                          ),
                        },
                        on: { "toggle-visibility": _vm.handleVisibility },
                      },
                      [
                        _c("select-section", {
                          attrs: {
                            disabled:
                              !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                            path: _vm.type,
                            name: "own",
                            options: _vm.ownOptions,
                            tabindex: _vm.tabIndex(300),
                          },
                          model: {
                            value: _vm.own,
                            callback: function ($$v) {
                              _vm.own = $$v
                            },
                            expression: "own",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "transition",
                      { attrs: { name: "slide-fade" } },
                      [
                        _vm.editVisibility ||
                        _vm.visibilityToggle(
                          _vm.currentApplication,
                          _vm._visibilityDataContext,
                          _vm.type + "['personal-details']['own']",
                          _vm.ownOptions,
                          "monthlyRent"
                        )
                          ? _c(
                              "field",
                              {
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.monthlyRent,
                                  ],
                                  "depends-upon": [_vm.visibilityPaths.own],
                                  "size-class": "col-lg-4",
                                  title: _vm.$t(
                                    "application-form.monthly-rent"
                                  ),
                                  "container-class": "dollar-prepend",
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("text-section", {
                                  attrs: {
                                    disabled:
                                      !_vm.hasCoApplicant &&
                                      _vm.isTypeCoApplicant,
                                    name: "monthly-rent",
                                    placeholder: "0",
                                    "class-name": "fe-num-field dollar",
                                    tabindex: _vm.tabIndex(300),
                                    label: _vm.$t(
                                      "application-form.monthly-rent"
                                    ),
                                  },
                                  model: {
                                    value: _vm.monthlyRent,
                                    callback: function ($$v) {
                                      _vm.monthlyRent = $$v
                                    },
                                    expression: "monthlyRent",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row align-items-start mb-4" },
                  [
                    _c(
                      "field",
                      {
                        attrs: {
                          "edit-visibility": _vm.editVisibility,
                          "visibility-paths": [_vm.visibilityPaths.addresses],
                          "size-class": "col-12",
                          title: _vm.editVisibility
                            ? _vm.$tc("application-form.address", 2)
                            : "",
                        },
                        on: { "toggle-visibility": _vm.handleVisibility },
                      },
                      [
                        _c(
                          "group-set",
                          {
                            attrs: {
                              disabled:
                                !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                              "group-name": _vm.$tc(
                                "application-form.address",
                                1
                              ),
                              multi: !_vm.editVisibility,
                              source:
                                _vm.dataByType["personal-details"]["addresses"],
                              path:
                                _vm.type + "['personal-details']['addresses']",
                              tabindex: _vm.tabIndex(300),
                            },
                            on: { duplicate: _vm.handleDuplicate },
                          },
                          [
                            _c(
                              "transition-group",
                              {
                                attrs: {
                                  name: "list",
                                  tag: "div",
                                  css: _vm.animateAddress,
                                },
                              },
                              _vm._l(_vm.addresses, function (address, index) {
                                return _c(
                                  "div",
                                  {
                                    key: _vm._f("hashId")(
                                      address.replicated
                                        ? _vm.identifier + "-" + index
                                        : _vm.identifier + "-" + address.line1
                                    ),
                                    staticClass: "reordable-item",
                                    class: { "mt-4": index !== 0 },
                                    attrs: {
                                      id: _vm._f("hashId")(
                                        _vm.identifier +
                                          "[personal-details][addresses][" +
                                          index +
                                          "]"
                                      ),
                                    },
                                  },
                                  [
                                    _c("address-section", {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "show-labels": !_vm.editVisibility,
                                        disabled:
                                          !_vm.hasCoApplicant &&
                                          _vm.isTypeCoApplicant,
                                        path:
                                          _vm.identifier +
                                          "[personal-details][addresses][" +
                                          index +
                                          "]",
                                        title: _vm.addressTitle(index),
                                        map: false,
                                        coapp: false,
                                        removable: "",
                                        time: "",
                                        "display-set-as-current": "",
                                        index: index,
                                        replicate: _vm.replicateAddress,
                                        "replicate-text": _vm.$t(
                                          "application-form.same-as-primary-applicant"
                                        ),
                                        "container-class": "mb-5",
                                        tabindex: _vm.tabIndex(300),
                                        "max-length": "",
                                      },
                                      on: {
                                        remove: function ($event) {
                                          return _vm.handleRemove(
                                            index,
                                            _vm.type +
                                              "['personal-details']['addresses']",
                                            "addresses"
                                          )
                                        },
                                        replicate: _vm.handleReplicateAddress,
                                        "set-as-current": function ($event) {
                                          return _vm.handleChangeAddressToCurrent(
                                            index
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.addresses[index],
                                        callback: function ($$v) {
                                          _vm.$set(_vm.addresses, index, $$v)
                                        },
                                        expression: "addresses[index]",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "employment-details",
            staticClass: "employment-details single-card card",
            attrs: { id: "employment" },
          },
          [
            _c("resize-sensor", {
              attrs: { debounce: 50 },
              on: {
                resized: function (el) {
                  return _vm.handleResize("employment-details")
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "resize-wrapper h-auto" }, [
              _c(
                "div",
                {
                  staticClass: "card-header px-5",
                  attrs: {
                    id: _vm._f("hashId")(_vm.identifier + "[employment]"),
                  },
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("application-card-header", {
                          attrs: {
                            "invisible-tile":
                              _vm.isTypeCoApplicant && !_vm.coAppsPage,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "application-form.employment-details"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "sub-title",
                              fn: function () {
                                return [
                                  _vm.firstName || _vm.lastName
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.fullNameWithSalutation)
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "extra",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.typeTitle) +
                                      "\n                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body px-5 pb-5" },
                [
                  _c(
                    "group-set",
                    {
                      attrs: {
                        disabled: !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                        "group-name": _vm.$tc("application-form.job", 1),
                        multi: !_vm.editVisibility,
                        source: _vm.dataByType["employment"],
                        path: _vm.type + "['employment']",
                        tabindex: _vm.tabIndex(400),
                      },
                      on: { duplicate: _vm.handleDuplicate },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "row" },
                        _vm._l(_vm.employment, function (job, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "col-12 mb-5 employment-wrapper",
                              attrs: {
                                id: _vm._f("hashId")(
                                  _vm.identifier + "[employment][" + index + "]"
                                ),
                                "group-index": index,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "row",
                                  attrs: { "group-index": index },
                                },
                                [
                                  _vm.employment.length > 1
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "form-container col-12",
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "bold my-0 text-secondary form-title form-title-removable text-lowercase",
                                            },
                                            [
                                              _c(
                                                "b-dropdown",
                                                {
                                                  attrs: {
                                                    split: "",
                                                    "split-variant":
                                                      "outline-secondary",
                                                    variant: "secondary",
                                                    "split-class": "no-pointer",
                                                    "toggle-class":
                                                      "no-padding",
                                                    size: "sm",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "button-content",
                                                        fn: function () {
                                                          return [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.ordinalIndex(
                                                                    index
                                                                  )
                                                                ) +
                                                                "\n                          " +
                                                                _vm._s(
                                                                  _vm.$tc(
                                                                    "application-form.job",
                                                                    1
                                                                  )
                                                                ) +
                                                                "\n                        "
                                                            ),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.employment,
                                                    function (
                                                      jobDropdown,
                                                      employmentIndex
                                                    ) {
                                                      return _c(
                                                        "b-dropdown-item",
                                                        {
                                                          key: employmentIndex,
                                                          staticClass:
                                                            "text-capitalize",
                                                          attrs: {
                                                            active:
                                                              index ===
                                                              employmentIndex,
                                                            disabled:
                                                              index ===
                                                              employmentIndex,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleReorderEmployment(
                                                                index,
                                                                employmentIndex
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.ordinalIndex(
                                                                  employmentIndex
                                                                )
                                                              ) +
                                                              "\n                          " +
                                                              _vm._s(
                                                                _vm.$tc(
                                                                  "application-form.job",
                                                                  1
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                [
                                                  _c("inline-prompt", {
                                                    ref: "prompt",
                                                    refInFor: true,
                                                    staticClass:
                                                      "d-inline-block bold text-gray ml-2",
                                                    attrs: {
                                                      "action-type": "delete",
                                                      "confirmation-text":
                                                        _vm.$t(
                                                          "application.messages.allDataWillBeLost"
                                                        ),
                                                    },
                                                    on: {
                                                      accept: function (
                                                        $event
                                                      ) {
                                                        return _vm.handleRemove(
                                                          index,
                                                          _vm.type +
                                                            "[employment]",
                                                          "employment-details"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.employment +
                                            "[employer-name]",
                                        ],
                                        "size-class":
                                          "col-lg-12 col-md-6 col-12",
                                        title: _vm.$t(
                                          "application-form.employer-name"
                                        ),
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("autocomplete-section", {
                                        attrs: {
                                          value: job["employer-name"],
                                          disabled:
                                            !_vm.hasCoApplicant &&
                                            _vm.isTypeCoApplicant,
                                          "max-length": "40",
                                          name: "employer-name",
                                          placeholder: _vm.$t(
                                            "application-form.employer-name-type"
                                          ),
                                          label: _vm.$t(
                                            "application-form.employer-name"
                                          ),
                                          "hidden-label": "",
                                          tabindex: _vm.tabIndex(400),
                                          "class-name": "company-address",
                                        },
                                        on: {
                                          "value-change": function ($event) {
                                            job["employer-name"] = $event
                                          },
                                          "phone-number-change": function (
                                            $event
                                          ) {
                                            return _vm.handleChangeWorkPhone(
                                              job,
                                              $event
                                            )
                                          },
                                          change: function ($event) {
                                            job["address"] = $event
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.employment +
                                            "[current-job]",
                                        ],
                                        "size-class":
                                          "col-lg-3 col-md-6 col-12 radio-field",
                                        title: _vm.$t(
                                          "application-form.current-job"
                                        ),
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("radio-section", {
                                        attrs: {
                                          path: _vm.type,
                                          disabled:
                                            !_vm.hasCoApplicant &&
                                            _vm.isTypeCoApplicant,
                                          name: "current-job-" + index,
                                          options: _vm.basicBinaryOptions,
                                          "full-width": true,
                                          tabindex: _vm.tabIndex(400),
                                          "emit-change-on-click": false,
                                        },
                                        model: {
                                          value: job["current-job"],
                                          callback: function ($$v) {
                                            _vm.$set(job, "current-job", $$v)
                                          },
                                          expression: "job['current-job']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.employment +
                                            "[employment-type]",
                                        ],
                                        "size-class":
                                          "col-lg-6 col-md-6 col-12",
                                        title: _vm.$t(
                                          "application-form.employment-type"
                                        ),
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("select-section", {
                                        attrs: {
                                          disabled:
                                            !_vm.hasCoApplicant &&
                                            _vm.isTypeCoApplicant,
                                          name: "employment-type",
                                          options: _vm.employmentTypeOptions,
                                          tabindex: _vm.tabIndex(400),
                                        },
                                        model: {
                                          value: job["employment-type"],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              job,
                                              "employment-type",
                                              $$v
                                            )
                                          },
                                          expression: "job['employment-type']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "visibility-paths": [
                                          _vm.visibilityPaths.employment +
                                            "[address]",
                                        ],
                                        "edit-visibility": _vm.editVisibility,
                                        "size-class": "col-12",
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("address-section", {
                                        attrs: {
                                          "edit-visibility": _vm.editVisibility,
                                          "show-labels": !_vm.editVisibility,
                                          disabled:
                                            !_vm.hasCoApplicant &&
                                            _vm.isTypeCoApplicant,
                                          path:
                                            _vm.identifier +
                                            "[employment][" +
                                            index +
                                            "][address]",
                                          title: _vm.$t(
                                            "application-form.employer-address"
                                          ),
                                          map: false,
                                          coapp: false,
                                          removable: false,
                                          time: false,
                                          "max-length": "",
                                          tabindex: _vm.tabIndex(400),
                                        },
                                        model: {
                                          value: job["address"],
                                          callback: function ($$v) {
                                            _vm.$set(job, "address", $$v)
                                          },
                                          expression: "job['address']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.employment +
                                            "[work-phone]",
                                        ],
                                        "size-class":
                                          "col-lg-6 col-md-6 col-12",
                                        "long-title": true,
                                        title: _vm.$t(
                                          "application-form.employer-phone-number"
                                        ),
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("text-section", {
                                        attrs: {
                                          disabled:
                                            !_vm.hasCoApplicant &&
                                            _vm.isTypeCoApplicant,
                                          name: "work-phone",
                                          "class-name": "fe-phone fe-phone-ext",
                                          tabindex: _vm.tabIndex(400),
                                        },
                                        model: {
                                          value: job["work-phone"],
                                          callback: function ($$v) {
                                            _vm.$set(job, "work-phone", $$v)
                                          },
                                          expression: "job['work-phone']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "row align-items-start",
                                  attrs: { "group-index": index },
                                },
                                [
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.employment +
                                            "[self-employed]",
                                          _vm.visibilityPaths.employment +
                                            "[operating-as]",
                                          _vm.visibilityPaths.employment +
                                            "[gross-revenue]",
                                        ],
                                        "size-class":
                                          "col-lg-4 col-md-6 col-12 radio-field",
                                        title: _vm.$t(
                                          "application-form.self-employed"
                                        ),
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("radio-section", {
                                        attrs: {
                                          disabled:
                                            !_vm.hasCoApplicant &&
                                            _vm.isTypeCoApplicant,
                                          path: _vm.type,
                                          name: "self-employed-" + index,
                                          options: _vm.binaryTrueShowsOptions,
                                          "full-width": true,
                                          tabindex: _vm.tabIndex(400),
                                        },
                                        model: {
                                          value: job["self-employed"],
                                          callback: function ($$v) {
                                            _vm.$set(job, "self-employed", $$v)
                                          },
                                          expression: "job['self-employed']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "transition",
                                    { attrs: { name: "slide-fade" } },
                                    [
                                      _vm.editVisibility ||
                                      _vm.visibilityToggle(
                                        _vm.currentApplication,
                                        job,
                                        _vm.type +
                                          "['employment'][" +
                                          index +
                                          "]['self-employed']",
                                        _vm.binaryTrueShowsOptions,
                                        "operating-as"
                                      )
                                        ? _c(
                                            "field",
                                            {
                                              attrs: {
                                                "visibility-paths": [
                                                  _vm.visibilityPaths
                                                    .employment +
                                                    "[operating-as]",
                                                ],
                                                "edit-visibility":
                                                  _vm.editVisibility,
                                                "depends-upon": [
                                                  _vm.visibilityPaths
                                                    .employment +
                                                    "[self-employed]",
                                                ],
                                                "size-class":
                                                  "col-lg-4 col-md-6 col-12 radio-field",
                                                title: _vm.$t(
                                                  "application-form.operating-as"
                                                ),
                                              },
                                              on: {
                                                "toggle-visibility":
                                                  _vm.handleVisibility,
                                              },
                                            },
                                            [
                                              _c("radio-section", {
                                                attrs: {
                                                  disabled:
                                                    !_vm.hasCoApplicant &&
                                                    _vm.isTypeCoApplicant,
                                                  path: _vm.type,
                                                  name: "operating-as-" + index,
                                                  options:
                                                    _vm.operatingAsOptions,
                                                  "full-width": true,
                                                  tabindex: _vm.tabIndex(400),
                                                },
                                                model: {
                                                  value: job["operating-as"],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      job,
                                                      "operating-as",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "job['operating-as']",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "transition",
                                    { attrs: { name: "slide-fade" } },
                                    [
                                      _vm.editVisibility ||
                                      _vm.visibilityToggle(
                                        _vm.currentApplication,
                                        job,
                                        _vm.type +
                                          "['employment'][" +
                                          index +
                                          "]['self-employed']",
                                        _vm.binaryTrueShowsOptions,
                                        "gross-revenue"
                                      )
                                        ? _c(
                                            "field",
                                            {
                                              attrs: {
                                                "visibility-paths": [
                                                  _vm.visibilityPaths
                                                    .employment +
                                                    "[gross-revenue]",
                                                ],
                                                "edit-visibility":
                                                  _vm.editVisibility,
                                                "depends-upon": [
                                                  _vm.visibilityPaths
                                                    .employment +
                                                    "[self-employed]",
                                                ],
                                                "size-class":
                                                  "col-lg-4 col-md-6 col-12 align-self-start",
                                                title: _vm.$t(
                                                  "application-form.gross-revenue"
                                                ),
                                                "container-class":
                                                  "dollar-prepend",
                                              },
                                              on: {
                                                "toggle-visibility":
                                                  _vm.handleVisibility,
                                              },
                                            },
                                            [
                                              _c("text-section", {
                                                attrs: {
                                                  disabled:
                                                    !_vm.hasCoApplicant &&
                                                    _vm.isTypeCoApplicant,
                                                  name: "gross-revenue",
                                                  "class-name": "dollar",
                                                  placeholder: "0",
                                                  tabindex: _vm.tabIndex(400),
                                                },
                                                model: {
                                                  value: job["gross-revenue"],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      job,
                                                      "gross-revenue",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "job['gross-revenue']",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "row",
                                  attrs: { "group-index": index },
                                },
                                [
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.employment +
                                            "[company-type]",
                                        ],
                                        "size-class":
                                          "col-lg-4 col-md-6 col-12",
                                        title: _vm.$t(
                                          "application-form.company-type"
                                        ),
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("text-section", {
                                        attrs: {
                                          disabled:
                                            !_vm.hasCoApplicant &&
                                            _vm.isTypeCoApplicant,
                                          name: "company-type",
                                          "max-length": "35",
                                          tabindex: _vm.tabIndex(400),
                                        },
                                        model: {
                                          value: job["company-type"],
                                          callback: function ($$v) {
                                            _vm.$set(job, "company-type", $$v)
                                          },
                                          expression: "job['company-type']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "row align-items-end",
                                  attrs: { "group-index": index },
                                },
                                [
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.employment +
                                            "[job-title]",
                                        ],
                                        "size-class":
                                          "col-lg-4 col-md-6 col-12",
                                        title: _vm.$t(
                                          "application-form.job-title"
                                        ),
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("text-section", {
                                        attrs: {
                                          disabled:
                                            !_vm.hasCoApplicant &&
                                            _vm.isTypeCoApplicant,
                                          name: "job-title",
                                          "max-length": "50",
                                          tabindex: _vm.tabIndex(400),
                                        },
                                        model: {
                                          value: job["job-title"],
                                          callback: function ($$v) {
                                            _vm.$set(job, "job-title", $$v)
                                          },
                                          expression: "job['job-title']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.employment +
                                            "[occupation]",
                                        ],
                                        "size-class":
                                          "col-lg-4 col-md-6 col-12",
                                        title: _vm.$t(
                                          "application-form.occupation"
                                        ),
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("select-section", {
                                        attrs: {
                                          disabled:
                                            !_vm.hasCoApplicant &&
                                            _vm.isTypeCoApplicant,
                                          name: "occupation",
                                          options: _vm.occupationOptions,
                                          tabindex: _vm.tabIndex(400),
                                        },
                                        model: {
                                          value: job["occupation"],
                                          callback: function ($$v) {
                                            _vm.$set(job, "occupation", $$v)
                                          },
                                          expression: "job['occupation']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "visibility-paths": [
                                          _vm.visibilityPaths.employment +
                                            "[income-type]",
                                        ],
                                        "edit-visibility": _vm.editVisibility,
                                        "size-class":
                                          "col-lg-4 col-md-6 col-12",
                                        title: _vm.$t(
                                          "application-form.income-type"
                                        ),
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("select-section", {
                                        attrs: {
                                          disabled:
                                            !_vm.hasCoApplicant &&
                                            _vm.isTypeCoApplicant,
                                          name: "income-type",
                                          options: _vm.incomeTypeOptions,
                                          tabindex: _vm.tabIndex(400),
                                        },
                                        model: {
                                          value: job["income-type"],
                                          callback: function ($$v) {
                                            _vm.$set(job, "income-type", $$v)
                                          },
                                          expression: "job['income-type']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "row align-items-end",
                                  attrs: { "group-index": index },
                                },
                                [
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.employment +
                                            "[industry-sector]",
                                        ],
                                        "size-class":
                                          "col-lg-4 col-md-6 col-12",
                                        title: _vm.$t(
                                          "application-form.industry-sector"
                                        ),
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("select-section", {
                                        attrs: {
                                          disabled:
                                            !_vm.hasCoApplicant &&
                                            _vm.isTypeCoApplicant,
                                          name: "industry-sector",
                                          options: _vm.industrySectorOptions,
                                          tabindex: _vm.tabIndex(400),
                                        },
                                        model: {
                                          value: job["industry-sector"],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              job,
                                              "industry-sector",
                                              $$v
                                            )
                                          },
                                          expression: "job['industry-sector']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.employment +
                                            "[income-period]",
                                        ],
                                        "size-class":
                                          "col-lg-4 col-md-6 col-12",
                                        title: _vm.$t(
                                          "application-form.income-period"
                                        ),
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("select-section", {
                                        attrs: {
                                          disabled:
                                            !_vm.hasCoApplicant &&
                                            _vm.isTypeCoApplicant,
                                          name: "income-period",
                                          options: _vm.incomePeriodOptions,
                                          tabindex: _vm.tabIndex(400),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.handleIncomePeriodChange(
                                              $event,
                                              job
                                            )
                                          },
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.handleIncomePeriodClick(
                                              $event,
                                              job
                                            )
                                          },
                                        },
                                        model: {
                                          value: job["income-period"],
                                          callback: function ($$v) {
                                            _vm.$set(job, "income-period", $$v)
                                          },
                                          expression: "job['income-period']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.employment +
                                            "[income-amount]",
                                        ],
                                        "size-class":
                                          "col-lg-4 col-md-6 col-12",
                                        title: _vm.$t(
                                          "application-form.income-amount"
                                        ),
                                        "container-class": "dollar-prepend",
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("text-section", {
                                        attrs: {
                                          disabled:
                                            !_vm.hasCoApplicant &&
                                            _vm.isTypeCoApplicant,
                                          name: "income-amount",
                                          placeholder: "0",
                                          "class-name": "dollar",
                                          tabindex: _vm.tabIndex(400),
                                        },
                                        model: {
                                          value: job["income-amount"],
                                          callback: function ($$v) {
                                            _vm.$set(job, "income-amount", $$v)
                                          },
                                          expression: "job['income-amount']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "row align-items-end",
                                  attrs: { "group-index": index },
                                },
                                [
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.employment +
                                            "[time-at-job]",
                                        ],
                                        "size-class": "col-lg-6 col-12",
                                        title: _vm.$t(
                                          "application-form.time-at-this-company"
                                        ),
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("years-months-section", {
                                        attrs: {
                                          name: "time-at-job",
                                          tabindex: _vm.tabIndex(400),
                                          placeholder: _vm.$t(
                                            "application-form.time-at-job"
                                          ),
                                          disabled:
                                            !_vm.hasCoApplicant &&
                                            _vm.isTypeCoApplicant,
                                        },
                                        model: {
                                          value: job["time-at-job"],
                                          callback: function ($$v) {
                                            _vm.$set(job, "time-at-job", $$v)
                                          },
                                          expression: "job['time-at-job']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.employment +
                                            "[months-in-industry]",
                                        ],
                                        "size-class": "col-lg-6 col-12",
                                        title: _vm.$t(
                                          "application-form.time-at-this-industry"
                                        ),
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("years-months-section", {
                                        attrs: {
                                          name: "time-at-industry",
                                          tabindex: _vm.tabIndex(400),
                                          placeholder: _vm.$t(
                                            "application-form.time-at-this-industry"
                                          ),
                                          disabled:
                                            !_vm.hasCoApplicant &&
                                            _vm.isTypeCoApplicant,
                                        },
                                        model: {
                                          value: job["months-in-industry"],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              job,
                                              "months-in-industry",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "job['months-in-industry']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "additional-income",
            staticClass: "additional-income single-card card",
            attrs: { id: "other-income" },
          },
          [
            _c("resize-sensor", {
              attrs: { debounce: 50 },
              on: {
                resized: function (el) {
                  return _vm.handleResize("additional-income")
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "resize-wrapper h-auto" }, [
              _c(
                "div",
                {
                  staticClass: "card-header px-5",
                  attrs: {
                    id: _vm._f("hashId")(_vm.identifier + "[other-income]"),
                  },
                },
                [
                  _c("div", { staticClass: "row align-items-center" }, [
                    _c(
                      "div",
                      { staticClass: "col-11" },
                      [
                        _c("application-card-header", {
                          attrs: {
                            "invisible-tile":
                              _vm.isTypeCoApplicant && !_vm.coAppsPage,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$tc(
                                          "application-form.additional-income",
                                          1
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "sub-title",
                              fn: function () {
                                return [
                                  _vm.firstName || _vm.lastName
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.fullNameWithSalutation)
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "extra",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.typeTitle) +
                                      "\n                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.editVisibility
                      ? _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("multiple-visibility-button", {
                              attrs: {
                                "visibility-paths":
                                  _vm.PagesVisibilityMap["additional-income"],
                                "applicant-type": _vm.applicantType,
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body px-5 pb-5" },
                [
                  _c(
                    "group-set",
                    {
                      attrs: {
                        disabled: !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                        "group-name": _vm.$t(
                          "application-form.additional-income"
                        ),
                        multi: !_vm.editVisibility,
                        path: _vm.type + "['other-income']",
                        source: _vm.dataByType["other-income"],
                        "start-empty": !_vm.editVisibility,
                        tabindex: _vm.tabIndex(500),
                      },
                      on: { duplicate: _vm.handleDuplicate },
                    },
                    _vm._l(_vm.otherIncome, function (additionalIncome, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "row align-items-end mb-5",
                          attrs: {
                            id: _vm._f("hashId")(
                              _vm.identifier + "[other-income][" + index + "]"
                            ),
                            "group-index": index,
                          },
                        },
                        [
                          !_vm.editVisibility
                            ? _c("field", {
                                attrs: {
                                  "size-class": "col-lg-12",
                                  "title-class":
                                    "text-secondary form-title-removable",
                                  title:
                                    _vm.ordinalIndex(index) +
                                    " " +
                                    _vm.$tc(
                                      "application-form.additional-income",
                                      1
                                    ),
                                  removable: !_vm.editVisibility,
                                  "remove-path": _vm.type + "['other-income']",
                                },
                                on: {
                                  remove: function (removePath) {
                                    return _vm.handleRemove(
                                      index,
                                      removePath,
                                      "additional-income",
                                      true
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.otherIncome + "[type]",
                                ],
                                "size-class": "col-lg-4",
                                title: _vm.$t("application-form.income-type"),
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("select-section", {
                                attrs: {
                                  disabled:
                                    !_vm.hasCoApplicant &&
                                    _vm.isTypeCoApplicant,
                                  name: "type",
                                  options: _vm.additionalIncomeTypeOptions,
                                  tabindex: _vm.tabIndex(500),
                                },
                                model: {
                                  value: additionalIncome["type"],
                                  callback: function ($$v) {
                                    _vm.$set(additionalIncome, "type", $$v)
                                  },
                                  expression: "additionalIncome['type']",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.otherIncome +
                                    "[income-period]",
                                ],
                                "size-class": "col-lg-4",
                                title: _vm.$t("application-form.income-period"),
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("select-section", {
                                attrs: {
                                  disabled:
                                    !_vm.hasCoApplicant &&
                                    _vm.isTypeCoApplicant,
                                  name: "income-period",
                                  options: _vm.incomePeriodOptions,
                                  tabindex: _vm.tabIndex(500),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleIncomePeriodChange(
                                      $event,
                                      additionalIncome
                                    )
                                  },
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.handleIncomePeriodClick(
                                      $event,
                                      additionalIncome
                                    )
                                  },
                                },
                                model: {
                                  value: additionalIncome["income-period"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      additionalIncome,
                                      "income-period",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "additionalIncome['income-period']",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.otherIncome + "[amount]",
                                ],
                                "size-class": "col-lg-4",
                                title: _vm.$t("application-form.income-amount"),
                                "container-class": "dollar-prepend",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("text-section", {
                                attrs: {
                                  disabled:
                                    !_vm.hasCoApplicant &&
                                    _vm.isTypeCoApplicant,
                                  name: "amount",
                                  placeholder: "0",
                                  "class-name": "dollar",
                                  tabindex: _vm.tabIndex(500),
                                  label: _vm.$t(
                                    "application-form.income-amount"
                                  ),
                                },
                                model: {
                                  value: additionalIncome["amount"],
                                  callback: function ($$v) {
                                    _vm.$set(additionalIncome, "amount", $$v)
                                  },
                                  expression: "additionalIncome['amount']",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.otherIncome +
                                    "[description]",
                                ],
                                "size-class": "col-lg-12",
                                title: _vm.$t(
                                  "application-form.additional-description"
                                ),
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("text-section", {
                                attrs: {
                                  disabled:
                                    !_vm.hasCoApplicant &&
                                    _vm.isTypeCoApplicant,
                                  name: "description",
                                  "max-length": "80",
                                  tabindex: _vm.tabIndex(500),
                                  label: _vm.$t(
                                    "application-form.additional-description"
                                  ),
                                },
                                model: {
                                  value: additionalIncome["description"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      additionalIncome,
                                      "description",
                                      $$v
                                    )
                                  },
                                  expression: "additionalIncome['description']",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "assets",
            staticClass: "assets single-card card",
            attrs: { id: "assets" },
          },
          [
            _c("resize-sensor", {
              attrs: { debounce: 50 },
              on: {
                resized: function (el) {
                  return _vm.handleResize("assets")
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "resize-wrapper h-auto" }, [
              _c(
                "div",
                {
                  staticClass: "card-header px-5",
                  attrs: { id: _vm._f("hashId")(_vm.identifier + "[assets]") },
                },
                [
                  _c("div", { staticClass: "row align-items-center" }, [
                    _c(
                      "div",
                      { staticClass: "col-11" },
                      [
                        _c("application-card-header", {
                          attrs: {
                            "invisible-tile":
                              _vm.isTypeCoApplicant && !_vm.coAppsPage,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$tc("application-form.asset", 2)
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "sub-title",
                              fn: function () {
                                return [
                                  _vm.firstName || _vm.lastName
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.fullNameWithSalutation)
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "extra",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.typeTitle) +
                                      "\n                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.editVisibility
                      ? _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("multiple-visibility-button", {
                              attrs: {
                                "visibility-paths":
                                  _vm.PagesVisibilityMap["assets"],
                                "applicant-type": _vm.applicantType,
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body px-5 pb-5" },
                [
                  _c(
                    "group-set",
                    {
                      attrs: {
                        disabled: !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                        "group-name": _vm.$tc("application-form.asset", 1),
                        multi: !_vm.editVisibility,
                        "show-additions-amount": !_vm.editVisibility,
                        path: _vm.type + "['assets']",
                        source: _vm.dataByType["assets"],
                        "start-empty": !_vm.editVisibility,
                        tabindex: _vm.tabIndex(600),
                      },
                      on: { duplicate: _vm.handleDuplicate },
                    },
                    _vm._l(_vm.assets, function (asset, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "row align-items-end mb-5",
                          attrs: {
                            id: _vm._f("hashId")(
                              _vm.identifier + "[assets][" + index + "]"
                            ),
                            "group-index": index,
                          },
                        },
                        [
                          !_vm.editVisibility
                            ? _c("field", {
                                attrs: {
                                  "visibility-paths": [
                                    _vm.visibilityPaths.assets + "[type]",
                                  ],
                                  "size-class": "col-lg-12",
                                  "title-class":
                                    "text-secondary form-title-removable",
                                  title:
                                    _vm.ordinalIndex(index) +
                                    " " +
                                    _vm.$tc("application-form.asset", 1),
                                  removable: !_vm.editVisibility,
                                  "remove-path": _vm.type + "['assets']",
                                },
                                on: {
                                  remove: function (removePath) {
                                    return _vm.handleRemove(
                                      index,
                                      removePath,
                                      "assets",
                                      true
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.assets + "[type]",
                                ],
                                "size-class": "col-lg-6",
                                title: _vm.$t("application-form.asset-type"),
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("select-section", {
                                attrs: {
                                  disabled:
                                    !_vm.hasCoApplicant &&
                                    _vm.isTypeCoApplicant,
                                  name: "type",
                                  options: _vm.assetTypeOptions,
                                  tabindex: _vm.tabIndex(600),
                                },
                                model: {
                                  value: asset["type"],
                                  callback: function ($$v) {
                                    _vm.$set(asset, "type", $$v)
                                  },
                                  expression: "asset['type']",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.assets + "[amount]",
                                ],
                                "size-class": "col-lg-6",
                                title: _vm.$t("application-form.value"),
                                "container-class": "dollar-prepend",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("text-section", {
                                attrs: {
                                  disabled:
                                    !_vm.hasCoApplicant &&
                                    _vm.isTypeCoApplicant,
                                  name: "amount",
                                  placeholder: "0",
                                  "class-name": "dollar",
                                  tabindex: _vm.tabIndex(600),
                                  label: _vm.$t("application-form.value"),
                                },
                                model: {
                                  value: asset["amount"],
                                  callback: function ($$v) {
                                    _vm.$set(asset, "amount", $$v)
                                  },
                                  expression: "asset['amount']",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.assets + "[description]",
                                ],
                                "size-class": "col-lg-12",
                                title: _vm.$t(
                                  "application-form.additional-description"
                                ),
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("text-section", {
                                attrs: {
                                  disabled:
                                    !_vm.hasCoApplicant &&
                                    _vm.isTypeCoApplicant,
                                  name: "description",
                                  tabindex: _vm.tabIndex(600),
                                  "max-length": "80",
                                  label: _vm.$t(
                                    "application-form.additional-description"
                                  ),
                                },
                                model: {
                                  value: asset["description"],
                                  callback: function ($$v) {
                                    _vm.$set(asset, "description", $$v)
                                  },
                                  expression: "asset['description']",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "liabilities",
            staticClass: "liabilities single-card card",
            attrs: { id: "liabilities" },
          },
          [
            _c("resize-sensor", {
              attrs: { debounce: 50 },
              on: {
                resized: function (el) {
                  return _vm.handleResize("liabilities")
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "resize-wrapper h-auto" }, [
              _c(
                "div",
                {
                  staticClass: "card-header px-5",
                  attrs: {
                    id: _vm._f("hashId")(_vm.identifier + "[liabilities]"),
                  },
                },
                [
                  _c("div", { staticClass: "row align-items-center" }, [
                    _c(
                      "div",
                      { staticClass: "col-11" },
                      [
                        _c("application-card-header", {
                          attrs: {
                            "invisible-tile":
                              _vm.isTypeCoApplicant && !_vm.coAppsPage,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$tc("application-form.liability", 2)
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "sub-title",
                              fn: function () {
                                return [
                                  _vm.firstName || _vm.lastName
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.fullNameWithSalutation)
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "extra",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.typeTitle) +
                                      "\n                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.editVisibility
                      ? _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("multiple-visibility-button", {
                              attrs: {
                                "visibility-paths":
                                  _vm.PagesVisibilityMap["liabilities"],
                                "applicant-type": _vm.applicantType,
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body px-5 pb-5" },
                [
                  _c(
                    "group-set",
                    {
                      attrs: {
                        disabled: !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                        "group-name": _vm.$tc("application-form.liability", 1),
                        multi: !_vm.editVisibility,
                        "show-additions-amount": !_vm.editVisibility,
                        path: _vm.type + "['liabilities']",
                        source: _vm.dataByType["liabilities"],
                        "start-empty": !_vm.editVisibility,
                        tabindex: _vm.tabIndex(700),
                      },
                      on: { duplicate: _vm.handleDuplicate },
                    },
                    _vm._l(_vm.liabilities, function (liability, index) {
                      return _c(
                        "div",
                        {
                          key: "liabilities-" + index,
                          staticClass: "row align-items-end mb-5",
                          attrs: {
                            id: _vm._f("hashId")(
                              _vm.identifier + "[liabilities][" + index + "]"
                            ),
                            "group-index": index,
                          },
                        },
                        [
                          !_vm.editVisibility
                            ? _c("field", {
                                attrs: {
                                  "size-class": "col-12",
                                  "title-class":
                                    "text-secondary form-title-removable",
                                  title:
                                    _vm.ordinalIndex(index) +
                                    " " +
                                    _vm.$tc("application-form.liability", 1),
                                  removable: !_vm.editVisibility,
                                  icon: liability["cb-scraped"]
                                    ? "fa-clone"
                                    : "",
                                  "icon-tooltip": liability["cb-scraped"]
                                    ? _vm.$t(
                                        "application.messages.thisLiabilityIsCopied"
                                      )
                                    : "",
                                  "remove-path": _vm.type + "['liabilities']",
                                },
                                on: {
                                  remove: function (removePath) {
                                    return _vm.handleRemove(
                                      index,
                                      removePath,
                                      "liabilities",
                                      true
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.liabilities + "[type]",
                                  _vm.visibilityPaths.liabilities + "[limit]",
                                ],
                                "size-class": "col-lg-4 col-md-6",
                                title: _vm.$t(
                                  "application-form.liability-type"
                                ),
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("select-section", {
                                attrs: {
                                  disabled:
                                    !_vm.hasCoApplicant &&
                                    _vm.isTypeCoApplicant,
                                  name: "type",
                                  options: _vm.filteredLiabilityTypeOptions,
                                  tabindex: _vm.tabIndex(700),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.calculateLiabilityPayment(index)
                                  },
                                },
                                model: {
                                  value: liability["type"],
                                  callback: function ($$v) {
                                    _vm.$set(liability, "type", $$v)
                                  },
                                  expression: "liability['type']",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "transition",
                            { attrs: { name: "slide-fade" } },
                            [
                              _c(
                                "field",
                                {
                                  attrs: {
                                    "edit-visibility": _vm.editVisibility,
                                    "visibility-paths": [
                                      _vm.visibilityPaths.liabilities +
                                        "[balance]",
                                    ],
                                    "size-class": "col-lg-4 col-md-6",
                                    "container-class": "dollar-prepend",
                                    title: _vm.$t("application-form.balance"),
                                  },
                                  on: {
                                    "toggle-visibility": _vm.handleVisibility,
                                  },
                                },
                                [
                                  _c("text-section", {
                                    attrs: {
                                      disabled:
                                        !_vm.hasCoApplicant &&
                                        _vm.isTypeCoApplicant,
                                      name: "limit",
                                      placeholder: "0",
                                      "class-name": "dollar",
                                      tabindex: _vm.tabIndex(700),
                                      label: _vm.$t("application-form.balance"),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.calculateLiabilityPayment(
                                          index
                                        )
                                      },
                                    },
                                    model: {
                                      value: liability["balance"],
                                      callback: function ($$v) {
                                        _vm.$set(liability, "balance", $$v)
                                      },
                                      expression: "liability['balance']",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.liabilities + "[payment]",
                                ],
                                "size-class": "col-lg-4 col-md-6",
                                "container-class": "dollar-prepend",
                                title: _vm.$t(
                                  "application-form.payment-monthly"
                                ),
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("text-section", {
                                key: "liability-payment-" + index,
                                attrs: {
                                  disabled:
                                    !_vm.hasCoApplicant &&
                                    _vm.isTypeCoApplicant,
                                  name: "limit",
                                  placeholder: "0",
                                  "class-name": "dollar",
                                  tabindex: _vm.tabIndex(700),
                                  label: _vm.$t(
                                    "application-form.payment-monthly"
                                  ),
                                },
                                model: {
                                  value: liability["payment"],
                                  callback: function ($$v) {
                                    _vm.$set(liability, "payment", $$v)
                                  },
                                  expression: "liability['payment']",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.editVisibility ||
                          _vm.visibilityToggle(
                            _vm.currentApplication,
                            liability,
                            _vm.type + "['liabilities'][" + index + "]['type']",
                            _vm.filteredLiabilityTypeOptions,
                            "limit"
                          )
                            ? _c(
                                "field",
                                {
                                  attrs: {
                                    "edit-visibility": _vm.editVisibility,
                                    "visibility-paths": [
                                      _vm.visibilityPaths.liabilities +
                                        "[limit]",
                                    ],
                                    "depends-upon": [
                                      _vm.visibilityPaths.liabilities +
                                        "[type]",
                                    ],
                                    "size-class": "col-lg-4 col-md-6",
                                    "container-class": "dollar-prepend",
                                    title: _vm.$t("application-form.limit"),
                                  },
                                  on: {
                                    "toggle-visibility": _vm.handleVisibility,
                                  },
                                },
                                [
                                  _c("text-section", {
                                    attrs: {
                                      disabled:
                                        !_vm.hasCoApplicant &&
                                        _vm.isTypeCoApplicant,
                                      name: "limit",
                                      placeholder: "0",
                                      "class-name": "dollar",
                                      tabindex: _vm.tabIndex(700),
                                      label: _vm.$t("application-form.limit"),
                                    },
                                    model: {
                                      value: liability["limit"],
                                      callback: function ($$v) {
                                        _vm.$set(liability, "limit", $$v)
                                      },
                                      expression: "liability['limit']",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.liabilities +
                                    "[maturity-date]",
                                ],
                                "size-class": "col-lg-4 col-md-6",
                                title: _vm.$t("application-form.maturity-date"),
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("date-section", {
                                attrs: {
                                  disabled:
                                    !_vm.hasCoApplicant &&
                                    _vm.isTypeCoApplicant,
                                  name: "maturity-date",
                                  placeholder: "YYYY-MM-DD",
                                  "class-name": "date-format",
                                  tabindex: _vm.tabIndex(700),
                                  label: _vm.$t(
                                    "application-form.maturity-date"
                                  ),
                                  calendar: "",
                                },
                                on: { change: _vm.handleSave },
                                model: {
                                  value: liability["maturity-date"],
                                  callback: function ($$v) {
                                    _vm.$set(liability, "maturity-date", $$v)
                                  },
                                  expression: "liability['maturity-date']",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.liabilities + "[payoff]",
                                ],
                                "size-class": "col-lg-4 col-md-6",
                                title: _vm.$t("application-form.payoff"),
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("select-section", {
                                attrs: {
                                  disabled:
                                    !_vm.hasCoApplicant &&
                                    _vm.isTypeCoApplicant,
                                  name: "payoff",
                                  options: _vm.liabilityPayoffOptions,
                                  tabindex: _vm.tabIndex(700),
                                },
                                model: {
                                  value: liability["payoff"],
                                  callback: function ($$v) {
                                    _vm.$set(liability, "payoff", $$v)
                                  },
                                  expression: "liability['payoff']",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.liabilities +
                                    "[description]",
                                ],
                                "size-class": "col-lg-12",
                                title: _vm.$t(
                                  "application-form.additional-description"
                                ),
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("text-section", {
                                attrs: {
                                  disabled:
                                    !_vm.hasCoApplicant &&
                                    _vm.isTypeCoApplicant,
                                  name: "description",
                                  "max-length": "80",
                                  tabindex: _vm.tabIndex(700),
                                  label: _vm.$t(
                                    "application-form.additional-description"
                                  ),
                                },
                                model: {
                                  value: liability["description"],
                                  callback: function ($$v) {
                                    _vm.$set(liability, "description", $$v)
                                  },
                                  expression: "liability['description']",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.editVisibility
          ? _c(
              "div",
              {
                ref: "other-properties",
                attrs: {
                  id: _vm._f("hashId")(_vm.identifier + "[other-properties]"),
                },
              },
              [
                _c("other-properties", {
                  attrs: {
                    "current-application": _vm.currentApplication,
                    "applicant-index": _vm.applicantIndex,
                    "edit-visibility": _vm.editVisibility,
                    "co-applicants-disabled":
                      !_vm.hasCoApplicant && _vm.isTypeCoApplicant,
                    "is-main-applicant-screen": _vm.isMainApplicantScreen,
                  },
                  on: {
                    "change-height": _vm.handleResize,
                    "height-remove": _vm.handleHeightRemove,
                    replicate: function ($event) {
                      return _vm.$emit("replicate")
                    },
                    save: function ($event) {
                      return _vm.$emit("save")
                    },
                    "toggle-visibility": _vm.handleVisibility,
                    "page-change": _vm.handlePageChange,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            title: _vm.$t("application-form.income-period-confirmation-title"),
            "ok-title": _vm.$t("global.words.yes"),
            "cancel-title": _vm.$t("global.words.no"),
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            "hide-header-close": "",
          },
          on: {
            cancel: _vm.cancelIncomePeriod,
            ok: function ($event) {
              _vm.previousIncomePeriod = []
            },
          },
          model: {
            value: _vm.showUncommonPeriodConfirmationModal,
            callback: function ($$v) {
              _vm.showUncommonPeriodConfirmationModal = $$v
            },
            expression: "showUncommonPeriodConfirmationModal",
          },
        },
        [
          _c("p", [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t(
                    "application-form.income-period-confirmation-message",
                    {
                      period: _vm.selectedIncomePeriod,
                    }
                  )
                ) +
                "\n    "
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }